import { createSelectOptionsFromSysEnums } from '../../../../../shared/form-elements/select';
import http from '../../../../../shared/http';

import endpoints from '../../../../../../config/endpoints';

const namespace = 'affiliate-geos';

// action types
const FETCH_LOOKUPS_SUCCESS = `${namespace}/fetch-lookups-success`;
const FETCH_LOOKUPS_ERROR = `${namespace}/fetch-lookups-error`;

// actions
export const actions = {
	locationsLookups: text => dispatch => {
		const request = http({
			url: `${endpoints.LOOKUPS.LOCATIONS}?query=${text}`,
			method: 'get',
			actions: [FETCH_LOOKUPS_SUCCESS, FETCH_LOOKUPS_ERROR]
		});

		return request(dispatch).then((action) => {
			if (action.type === FETCH_LOOKUPS_SUCCESS) {
				return {
					options: createSelectOptionsFromSysEnums(action.payload.data)
				};
			}
		});
	}
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/header/geos/index.js